import { useFormContext } from 'react-hook-form';
import { Task } from '../models';
import TaskLink from '../Maintenance/components/TaskLink';
import { LinkedTaskField } from './LinkedTaskField';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { selectTasks } from '../reducer';
import { useEffect } from 'react';
import { fetchTasks } from '../actions';

interface TaskLinkedTabProps {
  task?: Task;
  editing?: boolean;
}

export const TaskLinkedTab = ({ task, editing = false }: TaskLinkedTabProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const form = useFormContext();
  const tasks = useSelector(selectTasks);

  useEffect(() => {
    if (tasks.length == 0) {
      dispatch(fetchTasks());
    }
  }, [tasks]);
  return (
    <>
      {editing ? (
        <LinkedTaskField name="linkedTasks" tasks={tasks} />
      ) : (
        <TaskLink intl={intl} task={task} />
      )}
    </>
  );
};
